/* global angular */

import WebSocketEventService from '../../core/ace-content-events';
import Debug from '../../../../../../ace-debug';

const COMPONENT_NAME = 'ContentEventService';
const debug = new Debug (COMPONENT_NAME);

angular.module ('atex.aceui.service').factory (COMPONENT_NAME,
  ['$rootScope', '$timeout', '$q', 'ApplicationConfigurationService', 'AuthenticationService', factory]);

function factory ($rootScope, $timeout, $q, ApplicationConfigurationService, AuthenticationService) {
  const DEFAULT_CONFIGURATION = {
    eventTypes: ['CREATE', 'UPDATE', 'DELETE', 'WORKFLOW'],
    contentTypes: []
  };

  let API = {
    connected: false
  };

  const whenService = AuthenticationService.callWithAuthentication ((currentUser) => {
    debug.log ('Current user', JSON.parse (JSON.stringify (currentUser)));
    return ApplicationConfigurationService.getServiceConfigurationFor (COMPONENT_NAME)
      .then ((config) => {
        let options = Object.assign ({}, DEFAULT_CONFIGURATION, config);
        let serviceurl = atex.aceui.ServiceUtils.calculateServiceUrl (options, '/content-events');

        let url;

        try {
          url = new URL (serviceurl, window && window.location.origin);
        } catch (error) {
          return $q.reject (atex.aceui.error.Error({
            cause: 'Invalid url provided to ' + COMPONENT_NAME,
            origin: COMPONENT_NAME,
            rootCause: error,
            severity: atex.aceui.error.severities.MAJOR,
            type: atex.aceui.error.types.INVALID_PARAMETERS
          }));
        }

        if (url.protocol === 'http:') {
          url.protocol = 'ws:';
        } else if (url.protocol === 'https:') {
          url.protocol = 'wss:';
        }

        if (url && currentUser.token) {
          debug.log ('Creating core service');
          let service = new WebSocketEventService ({
            url,
            token: currentUser.token,

            subscriptions: {
              'CREATE': { eventType: 'CREATE', system: { contentType: options.contentTypes }},
              'UPDATE': { eventType: 'UPDATE', system: { contentType: options.contentTypes }},
              'DELETE': { eventType: 'DELETE', system: { contentType: options.contentTypes }},
              'WORKFLOW': { eventType: 'WORKFLOW', system: { contentType: options.contentTypes }}
            }
          });

          $rootScope.$on ('aceui:authenticationSuccess', (event, user) => {
            debug.log (' on authenticationSuccess', user);
            service.token = user.token;
            service.reconnectMode = true;
          });

          $rootScope.$on ('aceui:authenticationRequest', () => {
            debug.log ('on authenticationRequest');
            service.reconnectMode = false;
          });

          service.on ('error', (error) => {
            console.error('ERROR: subscriptionService', error);
          });

          service.on ('open', () => {
            debug.log ('open');
            API.connected = true;

            service.on ('connection-lost', (reason) => {
              debug.log ('connection-lost', reason);
              $timeout (() => API.connected = false);
  
              if (reason.code === 4010 || reason.code === 4011) {
                debug.log ('authenticationRequest');
                $rootScope.$broadcast ('aceui:authenticationRequest');
              }
            });
  
            service.on ('connection-resumed', () => {
              debug.log ('connection-resumed');
              $timeout (() => API.connected = true);
            });
  
            service.on ('close', (reason) => {
              debug.log ('close', reason);
              $timeout (() => API.connected = false);
  
              if (reason.code === 4010 || reason.code === 4011) {
                debug.log ('authenticationRequest')
                $rootScope.$broadcast ('aceui:authenticationRequest');
              }
            });
          });

          return service;

        } else if (!currentUser.token) {
          return $q.reject (atex.aceui.error.Error({
            origin: COMPONENT_NAME,
            cause: 'No token present.',
            type: atex.aceui.error.types.AUTHENTICATION_FAILED
          }));
        } else {
          return $q.reject (atex.aceui.error.Error({
            origin: COMPONENT_NAME,
            cause: 'No connection url configured for ' + COMPONENT_NAME,
            type: atex.aceui.error.types.INVALID_PARAMETERS
          }));
        }
      });
  });

  API.addSubscriptions = (subscriptions) => {
    whenService.then ((service) => {
      service.addSubscriptions (subscriptions);
    });
  };

  API.subscribe = (subscriptionName, callback) => {
    let unsubscriber;
    whenService.then ((service) => {
      unsubscriber = service.subscribe (subscriptionName, (eventData) => {
        $timeout(callback.call (this, eventData));
      });
    });
    return (() => {
      whenService.then (unsubscriber);
    });
  };

  API.pause = (subscriptionName) => {
    whenService.then ((service) => {
      if (Array.isArray (subscriptionName)) {
        subscriptionName.forEach ((subscr) => service.pause (subscr));
      } else {
        service.pause (subscriptionName);
      }
    });
  };

  API.resume = (subscriptionName) => {
    whenService.then ((service) => {
      if (Array.isArray (subscriptionName)) {
        subscriptionName.forEach ((subscr) => service.resume (subscr));
      } else {
        service.resume (subscriptionName);
      }
    });
  };

  return API;
}
